import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../../config/api";
import { BASE_API } from "../../../../../constants/apiUrls";
import { toast } from "../../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../../types";
import { PartnershipData } from "../../../../../types/webCms/aboutUs/partnerShip";

// get all
export const getAllPartnerShipAsync = createAsyncThunk<
  GetCommonData<PartnershipData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllPartnerShip", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomePartnership, {
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get fail");
    return rejectWithValue(error);
  }
});

// update
export const updatePartnerShipAsync = createAsyncThunk<
  null,
  PostRequest<PartnershipData, any>
>(
  "admin/updatePartnerShip",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomePartnership}`, data);

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "update fail");
      return rejectWithValue(error);
    }
  }
);

// Delete
export const DeletePartnetShipImageAync = createAsyncThunk<null, any>(
  "admin/deletePartnerImage",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.delete(
        `${BASE_API.deletePartnerImage}?imageName=${data.imageName}`
      );

      reRender && reRender(true);
      toast("success", "delete successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "delete fail");
      return rejectWithValue(error);
    }
  }
);
